import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

/**
 * RedditionTaxModel.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class RedditionTaxModel extends BaseAPIModel {
    fields() {
        return {
            pk: { readOnly: true, primaryKey: true }
        };
    }

    static getTree(params) {
        return fetcher.get(`/ticket/accountancy/reddition/${params.id}/tax-category/tax-tree`);
    }

    static listUrl({ organizationId, eventId, id_tax }) {
        if (id_tax) {
            return `/ticket/organizations/${organizationId}/accountancy/reddition/${eventId}/tax/${id_tax}`;
        } else {
            return `/ticket/organizations/${organizationId}/accountancy/reddition/${eventId}/tax`;
        }
    }
}
